// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import { connect } from 'react-redux'
import TimeStamp from './TimeStamp'

const TimeStamps = ({ createInfo, idRoot, lastModifiedInfo }) => (
  <div className={'padding-bottom-half'}>
    <TimeStamp
      dateLabel={'Created'}
      idRoot={`${idRoot}-created`}
      info={createInfo}
      userLabel={'Created by'} />
    <TimeStamp
      dateLabel={'Last updated'}
      idRoot={`${idRoot}-updated`}
      info={lastModifiedInfo}
      userLabel={'Modified by'} />
  </div>
)

TimeStamps.propTypes = {
  createInfo: object,
  sourceForm: string,
  idRoot: string.isRequired,
  lastModifiedInfo: object,
}

// if a sourceForm is specified, then grab the values from that,
// otherwise get them from the current dataset in databaseDetails
const mapStateToProps = ({ form }, { sourceForm }) => ({
  createInfo: form[sourceForm].initial.createInfo,
  lastModifiedInfo: form[sourceForm].initial.lastModifiedInfo,
})

export default connect(mapStateToProps)(TimeStamps)
